<template>
  <div>
    <training-member-toolbar :forced-member-id="this.userInfo.id" />
    <div class="card mx-md-5 mt-3 mb-3 bg-form">
      <card-header v-if="userInfo" :title="$t('evaluations.applyActivities')" :iconName="'file-person'" />
      <b-card-body>
        <b-alert variant="success" v-model="popSuccessAlert" dismissible> {{ this.successMessage }} </b-alert>
        <b-alert v-for="error in errors" :key="error.message" v-model="popAlert" variant="danger" dismissible>
          {{ error.message }}
        </b-alert>


        <b-overlay :show="isLoading" spinner-variant="primary" rounded="sm">
          <table style="margin-left: auto; margin-right: auto;">
            <tr>
              <th></th>
              <th>Εκπαιδευόμενος</th>
              <th>Παραστάτης</th>
            </tr>
            <tr>
              <td>Αρ. Μητρώου</td>
              <td>{{ applyActivity.member.id }}</td>
              <td>{{ applyActivity.memberValidator.id }}</td>
            </tr>
            <tr>
              <td>Ονοματεπώνυμο</td>
              <td>{{ applyActivity.member.surName }} {{ applyActivity.member.firstName }}</td>
              <td>{{ applyActivity.memberValidator.surName }} {{ applyActivity.memberValidator.firstName }}</td>
            </tr>
            <tr>
              <td>Κιν. Τηλέφωνο</td>
              <td>{{ applyActivity.member.cinfo.cellNo }}</td>
              <td>{{ applyActivity.memberValidator.cinfo.cellNo }}</td>
            </tr>
            <tr>
              <td>e-mail</td>
              <td>{{ applyActivity.member.cinfo.email }}</td>
              <td>{{ applyActivity.memberValidator.cinfo.email }}</td>
            </tr>
          </table>

          <hr />

          <b-form>
            <b-form-group id="input-module-id" :label="$t('applyActivity.title')" label-for="input-id"
              label-align="left">
              <b-form-input id="input-id" type="text" v-model="applyActivity.module.title" disabled
                placeholder=""></b-form-input>
            </b-form-group>

            <b-form-group id="input-module-id" :label="$t('applyActivity.method')" label-for="input-id"
              label-align="left">
              <b-form-input id="input-id" type="text" v-model="applyMethod" disabled placeholder=""></b-form-input>
            </b-form-group>

            <b-form-group id="input-module-id" :label="$t('applyActivity.status')" label-for="input-id"
              label-align="left">
              <b-form-input id="input-id" type="text" v-model="status" disabled placeholder=""></b-form-input>
            </b-form-group>

            <b-form-group id="input-module-id" :label="$t('applyActivity.dateCreated')" label-for="input-id"
              label-align="left">
              <b-form-input id="input-id" type="text" v-model="dateCreated" disabled placeholder=""></b-form-input>
            </b-form-group>

            <b-form-group id="input-module-id" :label="$t('applyActivity.dateAssigned')" label-for="input-id"
              label-align="left">
              <b-form-input id="input-id" type="text" v-model="dateAssigned" disabled placeholder=""></b-form-input>
            </b-form-group>

          </b-form>

          <hr />

          <the-attachment-manager :apply-activity="applyActivity" :viewOnly="false"></the-attachment-manager>

          <b-button
            v-if="this.applyActivity.applyActivityStatus === 'IN_PROGRESS' & (isTrainingAdmin || isAdmin || this.userInfo.id === this.applyActivity.memberValidator.id) && this.applyActivity.applyMethod !== 'IN_TRAINING'"
            class="esep-blue-bg float-left mt-2" @click.prevent="completeApplyActivity">
            Ολοκλήρωση
          </b-button>

          <b-button
            v-if="this.applyActivity.applyActivityStatus === 'IN_PROGRESS' & (isTrainingAdmin || isAdmin) && this.applyActivity.applyMethod !== 'IN_TRAINING'"
            class="esep-blue-bg float-left ml-2 mt-2" @click.prevent="failApplyActivity">
            Απόρριψη
          </b-button>

        </b-overlay>

      </b-card-body>
    </div>
  </div>
</template>

<script>
import CardHeader from '../../components/common/cardHeader.vue'
import trainingService from '../../services/training.service';
import { handleApiError } from '../../services/error.service';
import '../../assets/table.css';
import TheAttachmentManager from "@/components/TheAttachmentManager";
import TrainingMemberToolbar from "@/components/TrainingMemberToolbar";

export default {
  components: {
    TheAttachmentManager,
    CardHeader,
    TrainingMemberToolbar
  },
  computed: {
    applyMethod() {
      return this.moduleApplyMethods.find(({ value }) => value === this.applyActivity?.module.applyMethod).text;
    },
    status() {
      return this.statuses.find(({ value }) => value === this.applyActivity?.applyActivityStatus)?.text;
    },
    dateCreated() {
      return new Date(this.applyActivity.dateCreated).toLocaleDateString('el-GR');
    },
    dateAssigned() {
      return new Date(this.applyActivity.dateAssigned).toLocaleDateString('el-GR');
    },
  },
  mounted() {
    trainingService.getUserInfo(this.username).then(
      (response) => {
        this.userInfo = response.data;
        this.$store.state.userInfo = this.userInfo;
        this.getApplyActivity();
        this.fetchRoles();
      },
      (error) => {
        let errorMessage = handleApiError(error);
        this.handleError(errorMessage);
      }
    );
  },
  data() {
    return {
      userInfo: null,
      popSuccessAlert: false,
      popAlert: false,
      successMessage: null,
      errors: null,
      isAdmin: false,
      isTrainingAdmin: false,
      isTrainingMod: false,
      applyActivity: null,
      moduleApplyMethods: [
        { value: "NONE", text: this.$t('applyMethodEnums.NONE') },
        { value: "TRAINER", text: this.$t('applyMethodEnums.TRAINER') },
        { value: "TEXT_WRITING", text: this.$t('applyMethodEnums.TEXT_WRITING') },
        { value: "SEND_MATERIAL", text: this.$t('applyMethodEnums.SEND_MATERIAL') },
        { value: "IN_TRAINING", text: this.$t('applyMethodEnums.IN_TRAINING') }
      ],
      statuses: [
        { value: 'ASSIGN_PENDING', text: this.$t('trainingApplyActivityEnums.ASSIGN_PENDING') },
        { value: 'IN_PROGRESS', text: this.$t('trainingApplyActivityEnums.IN_PROGRESS') },
        { value: 'COMPLETED', text: this.$t('trainingApplyActivityEnums.COMPLETED') },
        { value: 'FAILED', text: this.$t('trainingApplyActivityEnums.FAILED') },
      ],
      isLoading: false
    }
  },
  methods: {
    showSuccess(successMessage) {
      this.successMessage = successMessage;
      this.popSuccessAlert = true;
    },
    handleError(errors) {
      errors.forEach(error => {
        error.message = this.$t(`error.${error.code}`);
      })
      this.errors = errors;
      this.popAlert = errors.length > 0;
    },
    fetchRoles() {
      for (var i = 0; i < this.userInfo.roles.length; i++) {
        if (this.userInfo.roles[i].name == "ADMIN") {
          this.isAdmin = true;
        } else if (this.userInfo.roles[i].name == "TRAINING_ADMIN") {
          this.isTrainingAdmin = true;
        } else if (this.userInfo.roles[i].name == "TRAINING_MOD") {
          this.isTrainingMod = true;
        }
      }
    },
    getApplyActivity() {
      trainingService.getApplyActivity(this.$route.params.id).then(
        (response) => {
          this.applyActivity = response.data;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.handleError(errorMessage);
        }
      )
    },
    completeApplyActivity() {
      this.isLoading = true;
      trainingService.completeApplyActivity(this.$route.params.id).then(
        (response) => {
          this.applyActivity = response.data;
          this.showSuccess(this.$t('applyActivity.applyActivityCompletedSuccessfully'));
          this.isLoading = false;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.handleError(errorMessage);
          this.isLoading = false;
        }
      )
    },
    failApplyActivity() {
      this.isLoading = true;
      trainingService.failApplyActivity(this.$route.params.id).then(
        (response) => {
          this.applyActivity = response.data;
          this.showSuccess(this.$t('applyActivity.applyActivityFailedSuccessfully'));
          this.isLoading = false;
        },
        (error) => {
          let errorMessage = handleApiError(error);
          this.handleError(errorMessage);
          this.isLoading = false;
        }
      )
    },
  }
}
</script>